import { getUserType } from '@surfline/web-common';
import config from '../config';

const adConfigMap = {
  contest_sos_top: {
    adUnit: '/1024858/SL_Cuervo_Top',
    adId: 'SL_Cuervo_Top',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_sos_mid: {
    adUnit: '/1024858/SL_Cuervo_MidPage',
    adId: 'SL_Cuervo_MidPage',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_sos_bottom: {
    adUnit: '/1024858/SL_Cuervo_Bottom',
    adId: 'SL_Cuervo_Bottom',
    adSizes: [
      [300, 250],
      [970, 250],
    ],
    adSizeDesktop: [970, 250],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'flexbanner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_top_2019: {
    adUnit: '/1024858/SL_WOTW_Top',
    adId: 'SL_WOTW_Top',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_mid_2019: {
    adUnit: '/1024858/SL_WOTW_MidPage',
    adId: 'SL_WOTW_MidPage',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_bottom_2019: {
    adUnit: '/1024858/SL_WOTW_Bottom',
    adId: 'SL_WOTW_Bottom',
    adSizes: [
      [300, 250],
      [728, 90],
      [970, 250],
    ],
    adSizeDesktop: [970, 250],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'flexbanner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_regional_top_2019: {
    adUnit: '/1024858/SL_WOTW_Regional_Top',
    adId: 'SL_WOTW_Regional_Top',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_regional_mid_2019: {
    adUnit: '/1024858/SL_WOTW_Regional_Mid',
    adId: 'SL_WOTW_Regional_Mid',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_regional_bottom_2019: {
    adUnit: '/1024858/SL_WOTW_Regional_Bottom',
    adId: 'SL_WOTW_Regional_Bottom',
    adSizes: [
      [300, 250],
      [970, 250],
    ],
    adSizeDesktop: [970, 250],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'flexbanner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_top_2020: {
    adUnit: '/1024858/SL_WOTW_Top20',
    adId: 'SL_WOTW_Top20',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_mid_2020: {
    adUnit: '/1024858/SL_WOTW_MidPage20',
    adId: 'SL_WOTW_MidPage20',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_bottom_2020: {
    adUnit: '/1024858/SL_WOTW_Bottom20',
    adId: 'SL_WOTW_Bottom20',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_regional_top_2020: {
    adUnit: '/1024858/SL_WOTW_Regional_Top20',
    adId: 'SL_WOTW_Regional_Top20',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_regional_mid_2020: {
    adUnit: '/1024858/SL_WOTW_Regional_Mid20',
    adId: 'SL_WOTW_Regional_Mid20',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_regional_bottom_2020: {
    adUnit: '/1024858/SL_WOTW_Regional_Bottom20',
    adId: 'SL_WOTW_Regional_Bottom20',
    adSizes: [
      [300, 250],
      [970, 250],
    ],
    adSizeDesktop: [970, 250],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'flexbanner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_top_2021: {
    adUnit: '/1024858/SL_WOTW_Top21',
    adId: 'SL_WOTW_Top21',
    adSizes: [
      [300, 250],
      [728, 90],
      [970, 250],
    ],
    adSizeDesktop: [970, 250],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'flexbanner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_mid_2021: {
    adUnit: '/1024858/SL_WOTW_MidPage21',
    adId: 'SL_WOTW_MidPage21',
    adSizes: [
      [300, 250],
      [728, 90],
      [970, 250],
    ],
    adSizeDesktop: [970, 250],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'flexbanner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_bottom_2021: {
    adUnit: '/1024858/SL_WOTW_Bottom21',
    adId: 'SL_WOTW_Bottom21',
    adSizes: [
      [300, 250],
      [728, 90],
      [970, 250],
    ],
    adSizeDesktop: [970, 250],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'flexbanner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_regional_top_2021: {
    adUnit: '/1024858/SL_WOTW_Regional_Top21',
    adId: 'SL_WOTW_Regional_Top21',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_regional_mid_2021: {
    adUnit: '/1024858/SL_WOTW_Regional_Mid21',
    adId: 'SL_WOTW_Regional_Mid21',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeDesktop: [728, 90],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  contest_regional_bottom_2021: {
    adUnit: '/1024858/SL_WOTW_Regional_Bottom21',
    adId: 'SL_WOTW_Regional_Bottom21',
    adSizes: [
      [300, 250],
      [970, 250],
    ],
    adSizeDesktop: [970, 250],
    adSizeMobile: [300, 250],
    adSizeMappingsSHE: [
      [[728, 0], 'flexbanner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'CONTEST',
  },
  feed: {
    adUnit: '/1024858/SL_HP_RR',
    adId: 'SL_HP_RR',
    adSizes: [[300, 600]],
    adSizeMappings: [
      [
        [1022, 200],
        [300, 600],
      ],
    ],
    adSizeMappingsSHE: [[[1022, 200], ['flexrec']]],
    adClass: 'sl-feed-ad__ad-item',
    adViewType: 'HOMEPAGE',
  },
  feed_mobile: {
    adUnit: '/1024858/SL_HP_RR',
    adId: 'SL_HP_RR_mobile',
    adSizes: [[300, 250]],
    adSizeMappings: [
      [
        [0, 0],
        [300, 250],
      ],
    ],
    adSizeMappingsSHE: [[[0, 0], 'medrec']],
    adClass: 'sl-feed-ad__ad-item',
    adViewType: 'HOMEPAGE',
  },
  homepage_feed_top: {
    adUnit: '/1024858/SL_HP_Feed_Top',
    adId: 'SL_HP_Feed_Top',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeMappings: [
      [
        [1256, 90],
        [728, 90],
      ],
      [
        [976, 0],
        [300, 250],
      ],
      [
        [728, 0],
        [728, 90],
      ],
      [
        [0, 0],
        [300, 250],
      ],
    ],
    adSizeMappingsSHE: [
      [[1256, 90], 'banner'],
      [[976, 0], 'medrec'],
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'FEED',
  },
  homepage_feed_bottom: {
    adUnit: '/1024858/SL_HP_Feed_Bottom',
    adId: 'SL_HP_Feed_Bottom',
    adSizes: [
      [300, 250],
      [728, 90],
    ],
    adSizeMappings: [
      [
        [1256, 90],
        [728, 90],
      ],
      [
        [976, 250],
        [300, 250],
      ],
      [
        [728, 90],
        [728, 90],
      ],
      [
        [0, 0],
        [300, 250],
      ],
    ],
    adSizeMappingsSHE: [
      [[1256, 0], 'banner'],
      [[976, 0], 'medrec'],
      [[728, 0], 'banner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'FEED',
  },
  homepage_bottom: {
    adUnit: '/1024858/SL_HP_Bottom',
    adId: 'SL_HP_Bottom',
    adSizes: [
      [970, 250],
      [970, 90],
      [728, 90],
      [300, 250],
    ],
    adSize: 'banner',
    adSizeMappings: [
      [
        [976, 250],
        [
          [970, 250],
          [970, 90],
          [728, 90],
        ],
      ],
      [
        [728, 90],
        [728, 90],
      ],
      [
        [0, 0],
        [300, 250],
      ],
    ],
    adSizeMappingsSHE: [
      [[728, 0], 'flexbanner'],
      [[0, 0], 'medrec'],
    ],
    adViewType: 'FEED',
  },
  'sl-multi-cam-companion': {
    adUnit: '/1024858/Position2',
    adId: 'Position2',
    adSize: 'medrec',
    adSizes: [[300, 250]],
    adSizeDesktop: [300, 250],
    adSizeMobile: [300, 250],
    adViewType: 'MULTI_CAM',
    adClass: 'sl-multi-cam-companion',
  },
  'sl-multi-cam-companion-mobile': {
    adUnit: '/1024858/Position2',
    adId: 'Position2',
    adSize: 'tinybanner',
    adSizes: [[320, 50]],
    adSizeDesktop: [320, 50],
    adSizeMobile: [320, 50],
    adViewType: 'MULTI_CAM',
    adClass: 'sl-multi-cam-companion-mobile',
  },
};

const sheAdTargetMap = {
  camId: 'pub_meta_1',
  areaID: 'pub_meta_2',
  regionID: 'pub_meta_3',
  subregionID: 'pub_meta_4',
  sst: 'pub_meta_5',
  usertype: 'pub_meta_6',
  contentCategoryId: 'pub_meta_7',
  contentSeriesId: 'pub_meta_8',
  contentTagId: 'pub_meta_9',
  viewType: 'pub_meta_10',
  contentKeyword: 'ci',
};

const mapAdTargets = (adTargets, userType, viewType) => {
  if (!config.useSheMedia) return [...adTargets, ['usertype', userType]];
  const mappedAdTargets = adTargets.map((target) => {
    const [key, value] = target;
    // eslint-disable-next-line
    const targetKey = sheAdTargetMap.hasOwnProperty(key) ? sheAdTargetMap[key] : key;
    return [targetKey, value];
  });
  return [
    ...mappedAdTargets,
    [sheAdTargetMap.usertype, userType],
    [sheAdTargetMap.viewType, viewType],
  ];
};

const loadAdConfig = (
  divIdentifier,
  adTargets = [],
  entitlements = [],
  isUser = false,
  adViewType
) => ({
  adViewType: adViewType || adConfigMap[divIdentifier]?.adViewType,
  ...adConfigMap[divIdentifier],
  adTargets: mapAdTargets(
    adTargets,
    getUserType(entitlements, isUser),
    adConfigMap[divIdentifier]?.adViewType
  ),
});

export default loadAdConfig;
